import { render, staticRenderFns } from "./OneTimePromoCodePage.vue?vue&type=template&id=63d6ac56&"
import script from "./OneTimePromoCodePage.vue?vue&type=script&lang=js&"
export * from "./OneTimePromoCodePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports